import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ViewComponent implements OnInit {
  businessId:any;
  businessData:any
  imageUrl=environment.apiUrls.imageUrl;



  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
    this.activatedroute.paramMap.subscribe(params => { 
      this.businessId = params.get('id'); 
      console.log('businessId',this.businessId)
     
  });

  }

  ngOnInit(): void {
    this.getBusinessById()
  }
  getBusinessById(){
    this.apiService.getBusinessById(this.businessId).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log(res)
        this.businessData =res.data 
      }
     

    })
  }
}
